import { render, staticRenderFns } from "./PreOrders.vue?vue&type=template&id=a68f21e2"
import script from "./PreOrders.vue?vue&type=script&lang=js"
export * from "./PreOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports